import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityActividadesAddFailure,
  entityActividadesAddRequest,
  entityActividadesAddSuccess,
  entityActividadesLoadFailure,
  entityActividadesLoadRequest,
  entityActividadesLoadSuccess
} from './entity-actividades.actions';

import { ActividadesService } from '@rpe/registro-personas-empresas-lib';

@Injectable()
export class ActividadesEffects {
  // load
  loadRequestActividades = createEffect(() =>
    this.actions$.pipe(
      ofType(entityActividadesLoadRequest),
      mergeMap(() =>
        this.actividadesService.getActividades().pipe(
          map((items) => entityActividadesLoadSuccess({ items })),
          catchError((error) => of(entityActividadesLoadFailure({ error })))
        )
      )
    )
  );

  // add
  addRequestActividad = createEffect(() =>
    this.actions$.pipe(
      ofType(entityActividadesAddRequest),
      switchMap((action) =>
        this.actividadesService.addActividades(action.item).pipe(
          map((item) => entityActividadesAddSuccess({ item })),
          catchError((error) => of(entityActividadesAddFailure({ error })))
        )
      )
    )
  );

  addSuccessActividad = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityActividadesAddSuccess),
        tap(() => this.router.navigate(['/actividades', 'modificacion']))
      ),
    { dispatch: false }
  );

  // change

  // delete

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private actividadesService: ActividadesService,
    private router: Router
  ) {
    this.actividadesService.url = environment.apiUrl;
  }
}
